var map = {
	"./adobe_ai.svg": 922,
	"./adobe_eps.svg": 8006,
	"./adobe_pdf.svg": 3274,
	"./adobe_psd.svg": 6309,
	"./app_android.svg": 2245,
	"./app_linux.svg": 1298,
	"./app_mac.svg": 4161,
	"./app_windows.svg": 135,
	"./binary.svg": 195,
	"./code.svg": 8611,
	"./compress.svg": 464,
	"./cube.svg": 7371,
	"./data_json.svg": 2941,
	"./data_yaml.svg": 5222,
	"./executable.svg": 2692,
	"./folder.svg": 56,
	"./folder_tree.svg": 4975,
	"./lang_c.svg": 38,
	"./lang_java.svg": 919,
	"./lang_javascript.svg": 5038,
	"./lang_python.svg": 7229,
	"./markup_html.svg": 8168,
	"./markup_markdown.svg": 2356,
	"./markup_svg.svg": 6963,
	"./markup_xml.svg": 4810,
	"./math.svg": 9798,
	"./music.svg": 8117,
	"./office_accdb.svg": 6636,
	"./office_csv.svg": 4465,
	"./office_doc.svg": 1707,
	"./office_docx.svg": 1497,
	"./office_ppt.svg": 5181,
	"./office_pptx.svg": 3759,
	"./office_vsd.svg": 1926,
	"./office_xls.svg": 2630,
	"./office_xlsx.svg": 2754,
	"./other.svg": 4170,
	"./picture.svg": 5546,
	"./query_sql.svg": 9453,
	"./script.svg": 6773,
	"./style_css.svg": 9739,
	"./text.svg": 8265,
	"./vector.svg": 8649,
	"./video.svg": 6245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5252;